import React, { FC, useMemo } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { MultiSelect, MultiSelectPropertiesInterface } from '@affstore-ds/uikit'

import { promoBannersFileFormatsEntity } from '../../entities/constants/promoBannersFileFormatsEntity'
import { commonTranslationKeys } from '../../shared/translations/common.translationKeys'
import { selectTranslationKeys } from '../../shared/translations/select.translationKeys'
import { promoBannersFileFormatsMultiSelectTranslationKeys } from './translations/promoBannersFileFormatsMultiSelect.translationKeys'

export const PromoBannerFileFormatsMultiSelect: FC<Omit<MultiSelectPropertiesInterface, 'data'>> = ({ label, ...rest }) => {
  const { i18n } = useI18n()

  const PROMO_BANNER_FILE_FORMATS_LIST_PREPARED = useMemo(
    () =>
      promoBannersFileFormatsEntity.PROMO_BANNER_FILE_FORMATS_LIST.map((format) => ({
        'data-testid': `promo-banner-file-format-item-${format.value}`,
        label: i18n.t(format.translationKey),
        value: format.value,
      })),
    [i18n],
  )

  return (
    <MultiSelect
      data-testid="promo-banner-sizes-multi-select"
      label={label || i18n.t(promoBannersFileFormatsMultiSelectTranslationKeys.promoFormatLabel)}
      bottomSheetTitle={label || i18n.t(promoBannersFileFormatsMultiSelectTranslationKeys.promoFormatLabel)}
      clearLabel={i18n.t(selectTranslationKeys.selectClear)}
      data={PROMO_BANNER_FILE_FORMATS_LIST_PREPARED}
      emptySearchLabel={i18n.t(commonTranslationKeys.commonNoData)}
      maxDropdownHeight={400}
      placeholder={i18n.t(promoBannersFileFormatsMultiSelectTranslationKeys.promoAllFormatsPlaceholder)}
      selectAllLabel={i18n.t(selectTranslationKeys.selectSelectAll)}
      variant="responsive"
      {...rest}
    />
  )
}
